/**
 * @author Code Lai（赖传峰）
 * @email codelai@staritgp.com
 * @date 2016/12/21
 */
import PropTypes from 'prop-types'

const Loading = props => {
  const { src, style } = props
  const inlineStyle = {
    margin: 'auto',
    background: `url(${src}) center no-repeat #fff`,
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...style,
  }
  return <div style={inlineStyle} />
}
Loading.version = '1.2.0'
Loading.propTypes = {
  src: PropTypes.string,
  style: PropTypes.object,
}
Loading.defaultProps = {
  src: '/img/loading_80_80.gif',
  style: {},
}

export default Loading
